import {ScreenElementChartJSON,
       ScreenElementChartModel,
       ScreenElementChartFactory,
       ChartWidget,
        ChartWidgetFactory} from './modelsDashboard';
import {FilterModel}  from './modelsFilter';
//************************************************//
//************************************************//

export interface BaseScreenElementJSON {
  Id_sys: string;
  Uuid_sys: string;
  ApiName_sys: string;
  Label_sys: string;
  Type_sys: string,
  PositionX_sys: number,
  PositionY_sys: number,
  Width_sys: number,
  Height_sys: number
}

export class BaseScreenElementModel {
  Id_sys: string;
  Uuid_sys: string;
  ApiName_sys: string;
  Label_sys: string;
  Type_sys: string;
  PositionX_sys: number;
  PositionY_sys: number;
  Width_sys: number;
  Height_sys: number;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Type_sys: string,
    PositionX_sys: number,
    PositionY_sys: number,
    Width_sys: number,
    Height_sys: number
  ) {
    this.Id_sys = Id_sys;
    this.Uuid_sys = Uuid_sys;
    this.Type_sys = Type_sys;
    this.ApiName_sys = ApiName_sys;
    this.Label_sys = Label_sys;
    this.Type_sys = Type_sys;
    this.PositionX_sys = PositionX_sys;
    this.PositionY_sys = PositionY_sys;
    this.Width_sys = Width_sys;
    this.Height_sys = Height_sys;
  }
}

export class BaseScreenElementFactory {
  fromJSON(json: BaseScreenElementJSON): BaseScreenElementModel {
    return new BaseScreenElementModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Type_sys,
      json.PositionX_sys,
      json.PositionY_sys,
      json.Width_sys,
      json.Height_sys
    );
  }
  toJSON(model: BaseScreenElementModel): BaseScreenElementJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Type_sys: model.Type_sys,
      PositionX_sys: model.PositionX_sys,
      PositionY_sys: model.PositionY_sys,
      Width_sys: model.Width_sys,
      Height_sys: model.Height_sys
    };
  }
}

//************************************************//

export interface DashboardScreenElementJSON extends BaseScreenElementJSON {
  config: any
}
export class DashboardScreenElementModel extends BaseScreenElementModel {

  chart: ScreenElementChartModel;

  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Type_sys: string,
    PositionX_sys: number,
    PositionY_sys: number,
    Width_sys: number,
    Height_sys: number,
    chart: ScreenElementChartModel
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys,
          Type_sys,
          PositionX_sys,
          PositionY_sys,
          Width_sys,
          Height_sys);
    this.chart = chart;
  }
}

export class DashboardScreenElementFactory {
  fromJSON(json: DashboardScreenElementJSON): DashboardScreenElementModel {
    const thisChart = new ScreenElementChartFactory().fromJSON(json.config.chart)
/*
    if(json.config.chart) {

      widgets = json.config.chart.widgets.map((thisWidget: any) => {
        //note: cannot use WidgetFactory, because a lot of
        //optional elements would be set to undefined then
        return thisWidget;
      })
    }
*/

    return new DashboardScreenElementModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Type_sys,
      json.PositionX_sys,
      json.PositionY_sys,
      json.Width_sys,
      json.Height_sys,
      thisChart
    );
  }
  toJSON(model: DashboardScreenElementModel): DashboardScreenElementJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Type_sys: model.Type_sys,
      PositionX_sys: model.PositionX_sys,
      PositionY_sys: model.PositionY_sys,
      Width_sys: model.Width_sys,
      Height_sys: model.Height_sys,
      config: {}
    }
  }
}

//************************************************//

export interface SearchScreenElementJSON extends BaseScreenElementJSON {
}
export class SearchScreenElementModel extends BaseScreenElementModel {
  constructor(
    Id_sys: string,
    Uuid_sys: string,
    ApiName_sys: string,
    Label_sys: string,
    Type_sys: string,
    PositionX_sys: number,
    PositionY_sys: number,
    Width_sys: number,
    Height_sys: number
  ) {
    super(Id_sys,
          Uuid_sys,
          ApiName_sys,
          Label_sys,
          Type_sys,
          PositionX_sys,
          PositionY_sys,
          Width_sys,
          Height_sys);
  }
}

export class SearchScreenElementFactory {
  fromJSON(json: SearchScreenElementJSON): SearchScreenElementModel {
    return new SearchScreenElementModel(
      json.Id_sys,
      json.Uuid_sys,
      json.ApiName_sys,
      json.Label_sys,
      json.Type_sys,
      json.PositionX_sys,
      json.PositionY_sys,
      json.Width_sys,
      json.Height_sys
    );
  }
  toJSON(model: SearchScreenElementModel): SearchScreenElementJSON {
    return {
      Id_sys: model.Id_sys,
      Uuid_sys: model.Uuid_sys,
      ApiName_sys: model.ApiName_sys,
      Label_sys: model.Label_sys,
      Type_sys: model.Type_sys,
      PositionX_sys: model.PositionX_sys,
      PositionY_sys: model.PositionY_sys,
      Width_sys: model.Width_sys,
      Height_sys: model.Height_sys
    }
  }
}
